import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ICountry } from '@shared/interfaces/country.interface';
import { IHiringFirm } from '@shared/interfaces/hiring-firm.interface';
import { Country } from '@shared/models/country.model';
import { SessionStorage } from 'ngx-webstorage';
import data from 'src/assets/data/states.json';

interface State {}

@Component({
    selector: 'app-phone-number-signup',
    templateUrl: './phone-number-signup.component.html',
    standalone: false
})
export class PhoneNumberSignupComponent implements OnInit {
  @SessionStorage() public countries: ICountry[];

  @Input() public formGroup: FormGroup;
  @Input() public language = String('en');
  @Input() public explainer = String('');

  @SessionStorage() private hiringFirm: IHiringFirm;

  public states: State[] = data;
  public mask = '00000000000000000000';
  public isUS = true;

  private defaultCountry: ICountry;

  constructor() {}

  ngOnInit(): void {
    this.defaultCountry =
      this.countries?.find((c: ICountry) => c.initial === 'US') ||
      new Country({
        initial: 'US',
        phoneCode: '1'
      });

    if (!!!this.hiringFirm || !!!this.countries) {
      return this.setCountryCode(this.defaultCountry);
    }

    // Map CA to US since they share the same country code
    const countryInitial = this.hiringFirm.country === 'CA' ? 'US' : (this.hiringFirm.country || 'US');

    const country: ICountry =
      this.countries.find(
        (c: ICountry) => countryInitial === c.initial
      ) || this.defaultCountry;

    return this.setCountryCode(country);
  }

  public updateCountryCode() {
    const countryCode = this.formGroup.value.countryInitial;
    let country = this.countries.find(
      (c: ICountry) => c.initial === countryCode
    );

    // Treat both US and CA as US (they share the same country code +1)
    if (country.initial === 'US' || countryCode === 'CA') {
      this.isUS = true;
    } else {
      this.isUS = false;
    }

    if (!!!country) {
      country = this.defaultCountry;
    }

    return this.formGroup.patchValue({
      country_code: country.phoneCode
    });
  }

  private setCountryCode(c: ICountry): void {
    return this.formGroup.patchValue({
      country_code: c.phoneCode,
      countryInitial: c.initial
    });
  }
}
